import { ListingBanner } from '@boozt/app/components/atoms';
import { DefaultLayout } from '@boozt/app/components/templates';
import { useApp } from '@boozt/app/context';
import { renderReactLegacy } from '@boozt/helper';
import { ListingPageSSR } from '@common/Listing/containers/ListingPage';

export default function ListingPage() {
    const { props, context } = useApp();
    const { listingPageSSR, banner = null } = props;

    return (
        <DefaultLayout>
            {!!banner && <ListingBanner banner={banner} />}
            {renderReactLegacy(ListingPageSSR, context, listingPageSSR)}
        </DefaultLayout>
    );
}
